import { CollapseProps, Collapse } from "antd"
import { IAttendanceRecord } from "../interface/shiftData"
import {
  formatDateLong,
  formatDay,
  formatSentenceCase,
  formatTime,
} from "../utils"
import upIcon from "assets/svg/chevron-up.svg"
import calenderIcon from "assets/images/calendar-icon.png"
import downIcon from "assets/svg/chevron-down.svg"
import addIcon from "assets/svg/plus.svg"
import { useState } from "react"
import { getFlags } from "../utils"
import { CollapseRow } from "../components/CollapseRow"

interface TimeSheetCollapseRowProps {
  groupBy: "day" | "week" | "month"
  records: IAttendanceRecord[]
  setShowAddReasonModal: React.Dispatch<React.SetStateAction<boolean>>
}

const TimesheetCollapseRow = ({
  records,
  setShowAddReasonModal,
  groupBy,
}: TimeSheetCollapseRowProps) => {
  const [activeKey, setActiveKey] = useState("")

  const items: CollapseProps["items"] = records
    .sort((a, b) => b.clockIn.localeCompare(a.clockIn))
    .map((item) => ({
      key: item.id?.toString(),
      label: (
        <span
          className="flex justify-between items-center gap-5"
          style={{ fontFamily: '"Circular Std", sans-serif' }}
        >
          <p className="text-[#62748E] text-sm active:text-[#0F172B]">
            {formatDateLong(item.clockIn)}
          </p>
          <button className="flex items-center gap-2">
            {activeKey === item.id?.toString() ? (
              <img
                src={upIcon}
                width={20}
                height={20}
              />
            ) : (
              <img
                src={downIcon}
                width={20}
                height={20}
              />
            )}
          </button>
        </span>
      ),
      children: (
        <CollapseRow
          key={item.id}
          rows={[
            {
              label: "Day",
              value: formatDay(item.clockIn),
            },
            {
              label: "Shift plan",
              value: (
                <div className="flex flex-col min-w-0">
                  <p
                    className="truncate min-w-0 text-sm font-semibold "
                    style={{ margin: "0" }}
                  >
                    {formatSentenceCase(item.shiftPlan?.title)}
                  </p>
                  <small className="flex items-center gap-1 text-slate-500">
                    <img
                      src={calenderIcon}
                      alt="calender-icon"
                    />
                    <span>{formatSentenceCase(item.shiftPlan?.type)}</span> plan
                  </small>
                </div>
              ),
            },
            {
              label: "Shift Period",
              value: item.shiftPeriod?.title,
            },
            {
              label: "Clock-in",
              value: formatTime(item.clockIn),
            },
            {
              label: "Clock-out",
              value: formatTime(item.clockOut),
            },
            {
              label: "Method",
              value: (
                <div>
                  <img
                    src={calenderIcon}
                    alt="calender-icon"
                  />
                  <p>{item.method}</p>
                </div>
              ),
            },
            {
              label: "Flags",
              value: (
                <div className="grid grid-cols-2 -mx-3">
                  {" "}
                  {getFlags(item).map((item, index) => (
                    <p
                      key={index}
                      className="border whitespace-nowrap border-[#CAD5E2] rounded-full mt-1 w-fit text-[11px] px-3 py-1 text-[#0F172B]"
                    >
                      {item}
                    </p>
                  ))}
                </div>
              ),
            },
            {
              label: "Reason",
              value: item.reason ? (
                item.reason || ""
              ) : (
                <span
                  className="flex items-center gap-1 cursor-pointer"
                  onClick={() => setShowAddReasonModal(true)}
                >
                  <img
                    src={addIcon}
                    width={15}
                    height={15}
                  />
                  add reason
                </span>
              ),
            },
            {
              label: "Status",
              value: (
                <span
                  className={`capitalize ${
                    item.approvalStatus === "Approved"
                      ? "text-[#0F172B]"
                      : item.approvalStatus === "Rejected"
                      ? "text-[#E7000B]"
                      : "text-[#DA7705]"
                  }`}
                >
                  {item.approvalStatus}
                </span>
              ),
            },
          ]}
        />
      ),
    }))

  return (
    <>
      <style>{`
      .ant-collapse-content {
        border-top: none !important;
      }
      .ant-collapse-content-box {
        padding: 0 !important;
      }
    `}</style>
      <Collapse
        accordion
        activeKey={activeKey}
        onChange={(key) => setActiveKey(key as string)}
        items={items}
        expandIcon={() => null}
        style={{ background: "transparent", border: "none" }}
        className="[&_.ant-collapse-item]:bg-white [&_.ant-collapse-item]:p-0 [&_.ant-collapse-item]:border [&_.ant-collapse-item]:border-[#E2E8F0] [&_.ant-collapse-item]:mb-2 [&_.ant-collapse-item]:rounded-lg [&_.ant-collapse-item]:overflow-hidden [&_.ant-collapse-header]:h-[44px] [&_.ant-collapse-header]:flex [&_.ant-collapse-header]:items-center"
      />
    </>
  )
}

export default TimesheetCollapseRow
